import { MONARK_API } from 'src/constants/env';
import apiFactory from 'src/api';

const api = apiFactory({ apiUrl: MONARK_API });

export default api;
